<script>
import Base from '@/plans/ZOOM_CLIPS/config/base';

import { isLastPlanTypeInPlantypeList } from '@/utils/index.js';

export default {
  name: 'ZoomClipsPlusBuyNow',
  extends: Base,
  computed: {
    canRmv() {
      return (this.$context.is.winback || this.$context.is.fromCampaignLink)
        ? !isLastPlanTypeInPlantypeList(
            this.planType,
            this.getSelectedPlans.map((p) => p.type),
          )
        : this.$context.type !== this.planType;
    },
  },
};
</script>
